// toast.component.ts

import { Component } from '@angular/core';
// import { MessageService } from 'primeng/api';

@Component({
      selector: 'app-toast',
      template: '',
      // providers: [MessageService],
})
export class ToastComponent {
      constructor(
            // private messageService: MessageService
      ) { }

      showSuccess(message: string): void {
            // this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
      }

      // showInfo(message: string): void {
      //       this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
      // }

      // showWarn(message: string): void {
      //       this.messageService.add({ severity: 'warn', summary: 'Warning', detail: message });
      // }

      // showError(message: string): void {
      //       this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
      // }
}
